import { createVNode as _createVNode } from "vue";
import { defineComponent } from 'vue';
import { internalSizeValidator, props } from './props';
import { toPxNum } from '../utils/elements';
import { isArray } from '../utils/shared';


var internalSizes = {
  mini: [4, 4],
  small: [6, 6],
  normal: [8, 12],
  large: [12, 20]
};
export default defineComponent({
  name: 'VarSpace',
  props,

  setup(props, _ref) {
    var {
      slots
    } = _ref;

    var getSize = (size, isInternalSize) => {
      return isInternalSize ? internalSizes[size] : isArray(size) ? size.map(toPxNum) : [toPxNum(size), toPxNum(size)];
    };

    return () => {
      var _slots$default;

      var {
        inline,
        justify,
        align,
        wrap,
        direction,
        size
      } = props;
      var children = (_slots$default = slots.default == null ? void 0 : slots.default()) != null ? _slots$default : [];
      var lastIndex = children.length - 1;
      var isInternalSize = internalSizeValidator(size);
      var [y, x] = getSize(size, isInternalSize);
      var spacers = children.map((child, index) => {
        var margin = '0';

        if (direction === 'row') {
          if (justify === 'start' || justify === 'center' || justify === 'end') {
            if (index !== lastIndex) {
              margin = y / 2 + "px " + x + "px " + y / 2 + "px 0";
            } else {
              margin = y / 2 + "px 0";
            }
          } else if (justify === 'space-around') {
            margin = y / 2 + "px " + x / 2 + "px";
          } else if (justify === 'space-between') {
            if (index === 0) {
              margin = y / 2 + "px " + x / 2 + "px " + y / 2 + "px 0";
            } else if (index === lastIndex) {
              margin = y / 2 + "px 0 " + y / 2 + "px " + x / 2 + "px";
            } else {
              margin = y / 2 + "px " + x / 2 + "px";
            }
          }
        }

        if (direction === 'column' && index !== lastIndex) {
          margin = "0 0 " + y + "px 0";
        }

        return _createVNode("div", {
          "style": {
            margin
          }
        }, [child]);
      });
      return _createVNode("div", {
        "class": ['var-space', 'var--box', inline ? 'var-space--inline' : null],
        "style": {
          flexDirection: direction,
          justifyContent: justify,
          alignItems: align,
          flexWrap: wrap ? 'wrap' : 'nowrap',
          margin: direction === 'row' ? "-" + y / 2 + "px 0" : undefined
        }
      }, [spacers]);
    };
  }

});